<template>
  <ion-modal :is-open="isOpen" @ionModalDidDismiss="closeModal">
    <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{modalTitle}}</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="closeModal"><i class="fa fa-times fa-2x"></i></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <slot></slot> <!-- اسلات برای محتوای متغیر -->
    </ion-content>
    </ion-page>
  </ion-modal>
</template>

<script>
import {IonModal, IonContent, IonHeader, IonToolbar, IonTitle, IonButton, IonPage} from '@ionic/vue';

export default {
  props: {
    modalTitle: {
      type: String,
      default: '',
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  components: {
    IonPage,
    IonModal,
    IonContent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButton
  },
  methods: {
    closeModal() {
      this.$emit('close');
    }
  }
}
</script>
